var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',[_c('div',{staticClass:"b-text-color--sonic-silver"},[_vm._v(" "+_vm._s(_vm.header)+" ")]),_c('LoginMessage',{attrs:{"message":_vm.message,"active":_vm.valid}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }